import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

export default function Header(){
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const location = useLocation();

  // Close menu when clicking overlay
  const handleOverlayClick = () => setMobileNavOpen(false);

  // Scroll progress effect
  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="btw-header">
      {/* Scroll Progress Bar */}
      <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }}></div>
      <div className="btw-logo">
        <Link to="/">
          <img src={process.env.PUBLIC_URL + '/BTW_Log1.png'} alt="Between the Walls Logo" style={{height: 'auto', width: 'auto', maxWidth: '200px'}} className="btw-logo-img" />
        </Link>
      </div>
      <div style={{display: 'flex', alignItems: 'center', marginLeft: 'auto', position: 'relative'}}>
        {/* Mobile hamburger */}
        <button
          className="btw-hamburger"
          aria-label="Toggle navigation"
          aria-controls="main-nav"
          aria-expanded={mobileNavOpen}
          onClick={() => setMobileNavOpen(!mobileNavOpen)}
        >
          <span className={`hb-line hb-line-1 ${mobileNavOpen ? 'open' : ''}`}></span>
          <span className={`hb-line hb-line-2 ${mobileNavOpen ? 'open' : ''}`}></span>
          <span className={`hb-line hb-line-3 ${mobileNavOpen ? 'open' : ''}`}></span>
        </button>

        {/* Overlay for mobile nav */}
        {mobileNavOpen && <div className="btw-nav-overlay" onClick={handleOverlayClick}></div>}

        <nav id="main-nav" className={`btw-nav ${mobileNavOpen ? 'open' : ''}`}> 
          {/* Our Projects - dropdown for desktop only */}
          {!mobileNavOpen && (
            <div
              className={`btw-link btw-dropdown`}
            >
              Our Projects
              {/* Desktop dropdown */}
              <div className="btw-dropdown-content">
                <Link to="/commercial" className={`btw-link ${location.pathname === '/commercial' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}><span>Commercial</span></Link>
                <Link to="/residential" className={`btw-link ${location.pathname === '/residential' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}><span>Residential</span></Link>
              </div>
            </div>
          )}
          {/* Mobile - show Commercial and Residential directly */}
          {mobileNavOpen && (
            <>
              <Link to="/commercial" className={`btw-link ${location.pathname === '/commercial' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}>Commercial</Link>
              <Link to="/residential" className={`btw-link ${location.pathname === '/residential' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}>Residential</Link>
            </>
          )}
          {/* Our Studio */}
          <Link to="/studio" className={`btw-link ${location.pathname === '/studio' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}>Our Studio</Link>
          {/* Our Story */}
          <Link to="/whatwedo" className={`btw-link ${location.pathname === '/whatwedo' ? 'active' : ''}`} onClick={() => setMobileNavOpen(false)}>Our Story</Link>
          <button className="btw-talk" onClick={() => { setMobileNavOpen(false); window.location.href = '/letstalk'; }}>Let's Talk</button>
        </nav>
      </div>
    </header>
  );
}
